<script setup lang="ts">
  import { computed, getCurrentInstance } from 'vue';
  import PosUiField from '@/components/pos-v2/ui/PosUiField.vue';
  import V2MenuCategorySelect from '@/components/v2/menu-import/editor/V2MenuCategorySelect.vue';
  import {
    INHERIT_REPORTING_VALUE,
    IReportingOption,
    reportingIdFromValue,
    reportingValue,
  } from '@/domain/catalog/reporting-options';
  import { nextDomId } from '@/utils/dom-id.utils';

  /**
   * «Categoría de reportes» (plan §5.12, §5.15): the store's leaf reporting
   * categories, and «Igual que su categoría» to keep the inherited one.
   * Renders nothing when the store has none.
   */
  const props = defineProps<{
    value?: number | null;
    /** The leaves (`useReportingOptions`). */
    leaves: IReportingOption[];
    disabled?: boolean;
  }>();

  const emit = defineEmits<{ (e: 'input', value: number | null): void }>();

  const proxy = getCurrentInstance()!.proxy;
  const t = (key: string) => String(proxy.$t(key));
  const labelId = nextDomId('reporting-category');

  const options = computed(() => [
    {
      value: INHERIT_REPORTING_VALUE,
      label: t('reportingCategories.inheritOption'),
    },
    ...props.leaves,
  ]);
</script>

<template>
  <PosUiField
    v-if="leaves.length"
    class="v2-catalog-reporting-field"
    :label="t('reportingCategories.itemFieldLabel')"
    :label-id="labelId"
    :hint="t('reportingCategories.itemFieldHint')"
  >
    <V2MenuCategorySelect
      :value="reportingValue(value ?? null)"
      :options="options"
      :label-id="labelId"
      :list-label="t('reportingCategories.itemFieldLabel')"
      :disabled="disabled"
      @input="emit('input', reportingIdFromValue($event))"
    />
  </PosUiField>
</template>
